export default function Section16() {
    const processSteps = [
        {
            title: "Discovery and Goal Setting",
            description:
                "We begin by understanding your business goals, audience, and what “conversion” means for you.",
        },
        {
            title: "CRO Audit and User Behavior Analysis",
            description:
                "Using tools like heatmaps, session recordings, and analytics, we study how users behave on your website. We find out what’s working and what needs improvement.",
        },
        {
            title: "Strategy and Hypothesis",
            description:
                "We create a plan to fix key conversion issues. For example, simplifying your checkout, improving mobile navigation, or making calls-to-action clearer.",
        },
        {
            title: "A/B Testing and Implementation",
            description:
                "We test real changes one at a time to see what increases conversions. This ensures every improvement is backed by data, not guesswork.",
        },
        {
            title: "Optimization and Reporting",
            description:
                "Once winning variations are identified, we apply them across your site and provide transparent reports showing measurable improvements in conversion rate and ROI.",
        },
        {
            title: "Continuous Growth",
            description:
                "CRO doesn’t stop after one round. We monitor and refine your site regularly to ensure consistent growth and better long-term performance.",
        },
    ];

    return (
        <div className="Section16 py-[30px] md:py-[30px] bg-white">
            {/* Section Heading */}
            <div className="text-center mb-16 max-w-4xl mx-auto">
                <h2 className="text-[26px] md:text-[30px] font-bold text-[#151515] leading-[32px] md:leading-[41px]">
                    Our Data-Driven <span className="text-[#DA2128]">CRO Process</span>
                </h2>
                <p className="mt-6 text-[#555] text-[16px] md:text-[18px] max-w-[700px] mx-auto">
                    We follow a proven, data-first process designed specifically for UAE markets.
                </p>
            </div>

            {/* Process Steps Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 md:gap-12 w-[90%] md:w-[85%] mx-auto">
                {processSteps.map((step, index) => (
                    <div
                        key={index}
                        className={`p-6 rounded-2xl shadow-md text-left transition ${index % 2 === 0
                            ? "bg-[#E42E35] text-white"
                            : "bg-white text-[#151515] border border-gray-200"
                            }`}
                    >
                        <h3 className="text-[18px] md:text-[20px] font-bold mb-3">
                            {step.title}
                        </h3>
                        <p className="text-[14px] md:text-[15px] leading-[22px]">
                            {step.description}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
}
